// extracted by mini-css-extract-plugin
export default {"buttonsGroup":"CancelMoveModal_buttonsGroup__ET3pC"};